<template>
    <swiper
        class="swiper"
        :options="swiperOptions"
    >
        <swiper-slide
            v-for="(item, index) in tiebaInfo.layer_list"
            :key="index"
            :style="{backgroundImage: isShopDrawer ? '' : 'url(' + panelBg + ')'}"
            class="swiper-slide"
        >
            <panel-item-view
                v-if="item.type === 'tieba_layer' && !isShopDrawer"
                :item="item"
                :is-shop-drawer="isShopDrawer"
                @handleCli="handleCli"
            />
            <panel-item-get
                v-if="item.type === 'shop_layer' && !isShopDrawer"
                :item="item"
                @handleCli="handleCli"
            />
            <!-- 应用商店下载弹窗专用 -->
            <panel-item-view
                v-if="item.type === 'tieba_layer' && isShopDrawer"
                :item="item"
                :is-shop-drawer="isShopDrawer"
                :app-detail="appDetail"
                :third-store-info="tiebaInfo.third_store_info"
                @handleCli="handleCli"
            />
            <!---------------------->
            <div v-if="tiebaInfo.layer_list.length > 1" class="panel-placeholder"></div>
        </swiper-slide>
        <div
            v-if="tiebaInfo.layer_list.length > 1"
            slot="pagination"
            class="swiper-pagination"
            :style="{bottom: isIOS ? '1vh' : '1.5vh'}"
        ></div>
    </swiper>
</template>

<script>
import TiebaNewWakeUp from '@baidu/tieba-new-wakeup';
import PanelItemGet from './tieba-float-panel-item-get.vue';
import PanelItemView from './tieba-float-panel-item-view.vue';
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import panelBg from 'public/assets/imgs/float-panel-bg.png';
import {isIOS} from '@/utils/browser';
export default {
    components: {
        Swiper,
        SwiperSlide,
        PanelItemGet,
        PanelItemView,
    },
    props: {
        tiebaInfo: {
            type: Object,
            default: () => {},
        },
        isShopDrawer: {
            type: Boolean,
            default: false,
        },
        appDetail: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        PbDownloadUrl() {
            if (this.isShopDrawer) {
                return this.tiebaInfo.third_store_info.community_url || '';
            }
            if (this.tiebaInfo.layer_list.length > 1) {
                return this.tiebaInfo.layer_list[1].tieba_pack_info.download_url || '';
            }
            return this.tiebaInfo.layer_list[0].tieba_pack_info.download_url || '';

        },
    },
    data() {
        return {
            panelBg: panelBg,
            swiperOptions: {
                autoplay: 4000,
                pagination: '.swiper-pagination',
                autoplayDisableOnInteraction: false,
                onTouchEnd: this.slideChange,
            },
            isIOS: isIOS(),
        };
    },
    methods: {
        handleCli(link, chat, token) {
            this.$root.report(token).then(() => {
                if (link) {
                    TiebaNewWakeUp.init({
                        page: 'tbwebview',
                        param: {
                            obj_source: 'wise',
                            locate: 'outer_game_mfl',
                            token: token,
                            url: encodeURIComponent('https://gamecenter.baidu.com/static/game/mergeshop.html?channel=2003'),
                        },
                        androidShoubaiGoCenterPage: false,
                        androidDownUrl: this.tiebaInfo.layer_list[0].tieba_pack_info.download_url,
                        ios: 'new',
                        waitTime: 3000,
                        iosDownUrl: isIOS ? this.appDetail.join_community_info.download_url_for_smart : '',
                    });
                }
                else {
                    TiebaNewWakeUp.init({
                        page: 'pb',
                        param: {
                            tid: chat.tid,
                            obj_source: 'wise',
                            locate: 'outer_game_joinqz',
                        },
                        androidShoubaiGoCenterPage: false,
                        androidDownUrl: this.PbDownloadUrl,
                        ios: 'new',
                        waitTime: 3000,
                        iosDownUrl: isIOS ? this.appDetail.join_community_info.download_url_for_smart : '',
                    });
                }
            });
        },
        slideChange() {
            this.$root.sendLog('click', 'slide_click');
        },
    },
};

</script>

<style lang="scss">
.swiper {
    width: 1140px;
    position: relative;
    .swiper-slide {
        border-radius: 36px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .panel-placeholder {
            width: 100%;
            height: 33px;
        }
    }
    .swiper-pagination {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 72px;
        height: 36px;
        .swiper-pagination-bullet {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #D8D8D8;
            &-active {
                width: 24px;
                height: 12px;
                border-radius: 12px;
                background-color: #858585;
            }
        }
    }
}

</style>